import { AccessorsMutatorsDecorator, isInstanceOf } from "../../helpers";
import { TranslatableModel } from "./translatable-model";
import { Property } from "./property.model";

/**
 * @class Country
 * @property {number} id
 * @property {string} code
 * @property {string} name
 * @property {string} currency
 * @property {string} status
 */
export class Country extends TranslatableModel {
  /**
   * @type {string[]}
   */
  static get translatableAttributes() {
    return ["name"];
  }

  static get validationModel() {
    return {
      name: {
        label: "COUNTRY_NAME_IN_ENGLISH",
        commonLabel: "Country Name",
      },
      name_ar: {
        label: "COUNTRY_NAME_IN_ARABIC",
        commonLabel: "Country Name",
      },
      code: {
        label: "COUNTRY_CODE",
      },
      xxx_code: {
        label: "COUNTRY_CODE",
      },
      shomoos_code: {
        label: "SHOMOOs_CODE",
      },
    };
  }

  setProperties(value) {
    if (!Array.isArray(value) || !isInstanceOf(Property, value[0])) {
      value = Property.factory(value);
    }

    return value;
  }
}

AccessorsMutatorsDecorator(
  "id",
  "code",
  ...Country.translatableAttributesWithLanguageAliases,
  "status",
  "properties",
  "is_gcc",
  "guests",
  "users",
  "billing_informations",
  "nic_code",
  "shomoos_code",
  "display_public",
  "xxx_code"
)(Country);



// WEBPACK FOOTER //
// ./src/pms-api/models/country.model.js